export default "__VITE_ASSET__9B_diXQA__"